/* eslint-disable jsx-a11y/alt-text */
import { Link } from "react-router-dom";
import { Chefs } from "../constants/InfoChef";

function Footer() {
  return (
    <div className="bg-[#303030] relative overflow-hidden">
      <div
        className="bg-no-repeat w-[1200px] h-[1200px] bg-[length:1200px_1200px] bg-center absolute top-[-280px] 
         left-[50%] ml-[-600px] animate-[spin_60s_linear_infinite] opacity-30 pointer-events-none"
        style={{
          backgroundImage:
            "url(//bizweb.dktcdn.net/100/485/241/themes/911577/assets/trongdong.png?1688627722165)",
        }}
      ></div>

      <div className="p-3">
        <div className="grid grid-cols-12 gap-5 md:gap-10 text-white p-3 md:p-12 font-medium text-sm ">
          {/* thông tin */}
          <div className="col-span-12 md:col-span-6 xl:col-span-4">
            <ul className="list-disc">
              <li className="mb-5 font-bold text-lg">THÔNG TIN</li>
              <li className="flex items-center gap-3 mb-4">
                <span>Yết-kiêu, Gia-Lộc, TP. Hải Dương</span>
              </li>
              <li className="flex items-center gap-3 mb-4">
                <span>Vp Bank: Mai Xuân Trường 804.677.666</span>
              </li>
              <li className="flex items-center gap-3 mb-4">
                <div>Telephone: 0565442171 - 0584.564.666</div>
              </li>
              <li className="flex items-center gap-3 mb-4">
                <span> Email:</span>
                <Link
                  to="https://mail.google.com/mail/u/0/#inbox"
                  className=" hover:text-primary transition"
                >
                  <span className="underline">truongmt1112@gmail.com</span>
                </Link>
              </li>
              <li className="flex items-center gap-3 mb-4">
                <span>Facebook:</span>

                <Link
                  to="https://www.facebook.com/profile.php?id=61559704733274"
                  className=" hover:text-primary transition underline"
                >
                  Nấu-cỗ-34-hải-dương
                </Link>
              </li>
            </ul>
          </div>

          {/* Đầu bếp */}
          <div className="col-span-12 md:col-span-6 xl:col-span-4">
            <ul className="list-disc">
              <li className="mb-5 font-bold text-lg">ĐẦU BẾP</li>
              {Chefs.map((item, index) => {
                return (
                  <li className="flex items-center gap-3 mb-4">
                    <span className="text-nowrap  min-w-[92px]">
                      {item.name}:
                    </span>
                    <Link
                      to={item.link}
                      className=" hover:text-primary transition underline"
                    >
                      {item.textLink}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Mạng xã hội */}
          <div className="col-span-12 md:col-span-6 xl:col-span-2">
            <ul className="list-disc">
              <li className="mb-5 font-bold text-lg">MẠNG XÃ HỘI</li>
              <li className="flex items-center gap-3 mb-5">
                <Link to={"https://zalo.me/0584564666"}>
                  <img
                    className="hover:opacity-80 transition"
                    width="32px"
                    src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/zalo.png?1700209535143"
                  ></img>
                </Link>
                <Link
                  to={"https://www.facebook.com/profile.php?id=100028980550225"}
                >
                  <img
                    className="hover:opacity-80 transition"
                    width="32px"
                    src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/facebook.png?1700209535143"
                  ></img>
                </Link>

                <Link to="https://mail.google.com/mail/u/0/#inbox">
                  <img
                    className="hover:opacity-80 transition"
                    width="32px"
                    src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/google.png?1700209535143"
                  ></img>
                </Link>
              </li>
            </ul>
          </div>

          {/*HÌNH THỨC THANH TOÁN*/}
          <div className="col-span-12 md:col-span-6 xl:col-span-2">
            <ul className="list-disc">
              <li className="mb-5 font-bold text-lg">HÌNH THỨC THANH TOÁN</li>
              <li className="flex gap-2">
                <img
                  width="60px"
                  src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/payment_1.png?1700209535143"
                ></img>
                <img
                  width="60px"
                  src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/payment_2.png?1700209535143"
                ></img>
                <img
                  width="60px"
                  src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/payment_3.png?1700209535143"
                ></img>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
